import {
  ApplicationState,
  createApplicationContext,
} from "app/entities/form-controller/model/store";

export const {
  ApplicationProvider: AbstractApplicationProvider,
  useApplicationStore,
} = createApplicationContext<ApplicationState<unknown>>();
